module.exports = __webpack_public_path__ + "static/media/team-invite-success.0be1ad24.jpg";